export const checkSchema = (item: any) => {
  if (
    item.schema &&
    item.schema.properties &&
    Object.keys(item.schema).length !== 0 &&
    Object.keys(item.schema.properties).length !== 0
  ) {
    return true;
  }
  return false;
};

// Reference actions are stateless option lookups: the dropdowns that call them
// pass every parameter per request and nothing reads a saved row, so they never
// render as a configuration section (same rule as the creation screens'
// isConfigurableAction).
export const isActionVisible = (item: any) => {
  if (item?.type === 'reference') {
    return false;
  }
  if (item.schema?.is_executable === true) {
    return true;
  }
  return checkSchema(item);
};
